import type { CSSProperties } from 'react';
import { INK, STAGE_STYLES, TEMPERATURE_STYLES, type LeadStageKey } from '../../lib/leads/leadView';
import type { LeadQuality } from '../../types/lead';

// THE STATUS CHIP AND THE TEMPERATURE DOT (Leads centre v2). Both looks read the ONE map in src/lib/leads/leadView.ts: the staff look
// takes its classes from it, the portal look takes its fill and ring through CSS variables the `data-kc-theme='kyck'` rules read
// (src/index.css). The colour is never the only signal: the chip always carries its word, and every fill takes ink text.

export function StageChip({ stage, testId }: { stage: LeadStageKey; testId?: string }) {
  const s = STAGE_STYLES[stage];
  const style = { '--kc-stage-fill': s.portalFill ?? 'transparent', '--kc-stage-ring': s.portalRing ?? 'transparent', '--kc-ink': INK } as CSSProperties;
  return (
    <span className={`kc-stage kc-pill inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${s.staffClass}`} data-stage={stage} style={style} data-testid={testId ?? 'stage-chip'}>
      {s.label}
    </span>
  );
}

export function TemperatureDot({ quality, testId }: { quality: LeadQuality; testId?: string }) {
  if (quality === 'unknown') return null;
  const t = TEMPERATURE_STYLES[quality];
  return (
    <span className="kc-temp inline-flex items-center gap-1 text-xs text-muted-foreground" data-testid={testId ?? 'temperature'}>
      <span aria-hidden className="inline-block h-2 w-2 rounded-full" style={{ background: t.dot }} />
      {t.label}
    </span>
  );
}
